import * as IconSelector from '../icons';

export const tiposPago = [
    {
        value: null,
        label: 'Sin definir',
        description: 'No se ha definido',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: 'Efectivo',
        label: 'Efectivo',
        description: 'Uso Metalico',
        icon: IconSelector.PointIcon,
        color: 'Green'
    },
    {
        value: 'Transferencia',
        label: 'Transferencia',
        description: 'Transferencia Bancaria',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: 'Tarjeta',
        label: 'Tarjeta',
        description: 'Tarjeta',
        icon: IconSelector.PointIcon,
        color: 'Brown'
    },
    {
        value: 'Domiciliacion',
        label: 'Domiciliación',
        description: 'Domiciliación Bancaria',
        icon: IconSelector.PointIcon,
        color: 'Orange'
    },
    {
        value: 'Pagare',
        label: 'Pagaré',
        description: 'Emisión de efectos',
        icon: IconSelector.PointIcon,
        color: 'Red'
    }
];
